export default "__VITE_ASSET__O7hsn3zo__"